import { CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { FloatPanel, StudioButton } from "@/features/studio/theme";

interface SuccessScreenProps {
	title: string;
	description: string;
	actionLabel: string;
	onAction: () => void;
	notice?: {
		title: string;
		message: string;
	};
	className?: string;
}

function SuccessScreen({
	title,
	description,
	actionLabel,
	onAction,
	notice,
	className,
}: SuccessScreenProps) {
	return (
		<FloatPanel elevation={2} padding="40px 32px" className={cn("text-center", className)}>
			<div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-dashboard-pill-active-bg">
				<CheckCircle2 className="h-8 w-8 text-dashboard-accent-dark" />
			</div>

			<h2 className="font-display font-semibold text-2xl text-dashboard-text mb-2">
				{title}
			</h2>
			<p className="font-body text-sm text-dashboard-muted mb-6 leading-relaxed">
				{description}
			</p>

			{notice && (
				<div className="mb-6 rounded-xl p-4 text-left border bg-dashboard-surface border-dashboard-border">
					<p className="font-body text-[13px] text-dashboard-text leading-normal">
						<strong className="font-semibold">{notice.title}</strong> {notice.message}
					</p>
				</div>
			)}

			<StudioButton onClick={onAction} variant="primary" style={{ width: "100%" }}>
				{actionLabel}
			</StudioButton>
		</FloatPanel>
	);
}

export { SuccessScreen };
